import { writable } from 'svelte/store';

export interface FailedRequest {
	url: string;
	request: Request;
	body?: object;
}

export enum RetryStatus {
	SUCCESS = 'success',
	IN_PROGRESS = 'in_progress',
	INVALID = 'invalid',
	SKIP = 'skip',
}

function createIsRetrying() {
	const { subscribe, set, update } = writable<RetryStatus>(RetryStatus.INVALID);

	return {
		subscribe,
		update: (value: RetryStatus) => {
			update(() => {
				return value;
			});
		},
		reset: () => set(RetryStatus.INVALID),
	};
}

export const isRetrying = createIsRetrying();
